// src/api/panelApi.js
//
// Panel operativo del negocio (métricas del día/rango).

import { api } from './apiClient';

export const panel = {
  /**
   * Snapshot del panel del negocio para un rango de fechas.
   * Si no se pasan fechas → hoy.
   */
  negocio: (desde, hasta) =>
    api.get('/api/holaveci/panel/negocio', {
      query: { desde, hasta },
    }),
};
